import { StateSchema } from 'app/providers/StoreProvider';

export const getNavigationBlockDialogIsShown = (state: StateSchema) =>
    state.navigationBlock.showDialog;

export const getNavigationIsBlocked = (state: StateSchema) =>
    state.navigationBlock.navBlocked;

export const getAllowedRoutes = (state: StateSchema) =>
    state.navigationBlock.allowedRoutes;
